import download from '../images/download-white.svg';
import { useParams } from 'react-router-dom';
// import share from '../images/share.svg';
// import arrow from '../images/arrow-dark.svg';
import check from '../images/check-white-thin.svg';
import { generateCertificate, startDownloadCertificate } from '@/services/certificate';
import { VersionAccountStatus, FormationType } from '@/types';
import { useApiService } from '@/hooks/useApiService';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function VersionSuccess() {
    const { formationId, versionId } = useParams();
    const { getFormation, getVersionAccountStatus } = useApiService();
    const [certificateStatus, setCertificateStatus] = useState<VersionAccountStatus>();

    const { t } = useTranslation();
    const [formation, setFormation] = useState<FormationType>();

    const [pdfUrl, setPdfUrl] = useState<string | null>(null);

    const theme = formation?.theme || 'indigo';

    const downloadCertificate = () => {
        const data = certificateStatus;
        console.log('certificate', data);
        if (!data || !pdfUrl) return;
        startDownloadCertificate(
            t(formation?.name ?? '') +
                '_' +
                data.certificate?.first_name.toLowerCase() +
                data.certificate?.last_name.toLowerCase() +
                '_certificate.pdf',
            pdfUrl
        );
    };

    useEffect(() => {
        const fetchData = async () => {
            if (formationId && versionId) {
                const status = await getVersionAccountStatus(formationId, versionId);
                setCertificateStatus(status);

                if (status) {
                    const formationSetted = await getFormation(status.formation_id);
                    setFormation(formationSetted);

                    const url = await generateCertificate({
                        theme: formationSetted?.theme || 'indigo',
                        firstname: status?.certificate?.first_name || '',
                        last_name: status?.certificate?.last_name || '',
                        formationName: t(formationSetted?.name ?? ''),
                        deliveryDate: status?.certificate?.finished_date || '',
                        certificate_number: `n°${
                            typeof status?.certificate?.certificate_number === 'number'
                                ? status.certificate.certificate_number.toString().padStart(8, '0')
                                : '00000000'
                        }`,
                    });
                    setPdfUrl(url);
                }

                // setPdfUrl(
                //     `https://d3w0ywzdneepfx.cloudfront.net/pdfjs-4.9.155-dist/web/viewer.html?file=${encodeURIComponent(
                //         url
                //     )}`
                // );
            }
        };

        fetchData().catch(console.error);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        return () => {
            // Cleanup function
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
        };
    }, [pdfUrl]);

    return (
        <div className="flex flex-col w-full items-center mb-10">
            <div className="relative z-10 flex w-full flex-col items-center justify-center">
                <div className="flex flex-row items-center">
                    <div
                        className={`flex mr-3 items-center justify-center bg-ar-${theme}/100 w-9 h-9 border-[2.5px] border-white rounded-full shadow-${theme} `}
                    >
                        <img className="h-[11px]" src={check} alt="Check" />
                    </div>
                    <h1 className="text-2xl font-semibold text-text-dark">{t('school_finished_formation')}</h1>
                </div>
                <p className="mt-4 max-w-[400px] text-center text-xl sm:text-xl font-semibold text-text-grey">
                    {t('school_ready_to_go')}
                </p>
            </div>
            <div className="w-full gap-4 mt-16">
                {/* <div className="flex flex-col bg-white rounded-lg shadow-longshadow py-10 px-12">
                    <h2 className="text-xl sm:text-xl font-semibold text-text-dark">{t('school_badges')}</h2>
                    <p className="mt-4 max-w-lg text-center text-base sm:text-base font-semibold text-text-grey sm:text-left">
                        {t('school_badge_explanation')}
                    </p>
                    <div className="relative flex justify-center items-center mt-7 py-8 bg-[#FAFAFA] border border-[#F1F1F1] rounded-md">
                        <button className="absolute flex w-10 h-10 -top-5 right-4 justify-center items-center active:shadow-blue hover:shadow-blueactive cursor-pointer rounded-full bg-gradient-to-b from-[#6F7DFF] to-[#5D6DFA] text-center text-lg font-semibold text-white transition-all duration-200 ease-in-out hover:scale-101 active:scale-100 active:shadow-none">
                            <img className="w-[26px] h-[26px]" src={download} alt="Download" />
                        </button>
                        <img
                            className="pointer-events-none w-[150px] select-none shadow-sm border border-[#F4F4F4] rounded-[5px]"
                            src={`/images/badge-${theme}.svg`}
                            alt="Archireport certified badge"
                        />
                    </div>
                    <div className="flex flex-col mt-7">
                        <div className="flex flex-row justify-between items-center">
                            <p className="text-text-grey font-semibold text-sm">{t('school_html_integration')}</p>
                            <button className={`text-sm font-semibold text-ar-${theme}`}>{t('school_copy')}</button>
                        </div>
                        <div className="relative flex items-center mt-2 p-4 bg-[#FAFAFA] border border-[#F1F1F1] rounded-md overflow-x-scroll">
                            <p className="text-text-grey font-medium text-sm">
                                igmsrc=www.archireport.com/leliendelimage/codedelimageoupas/
                            </p>
                        </div>
                    </div>
                </div> */}
                <div className="flex flex-col w-full bg-white rounded-lg shadow-longshadow py-10 px-12">
                    <h2 className="text-xl sm:text-xl font-semibold text-text-dark">{t('school_pdf_certif')}</h2>
                    <p className="mt-4 text-center text-base sm:text-base font-semibold text-text-grey sm:text-left">
                        {t('school_freshly_graduated')}
                    </p>
                    <div className="relative flex justify-center items-center mt-7 px-14 py-8 bg-[#FAFAFA] border border-[#F1F1F1] rounded-md">
                        <button
                            className={`absolute flex w-10 h-10 -top-5 right-4 justify-center items-center active:shadow-blue hover:shadow-blueactive cursor-pointer rounded-full bg-gradient-to-b from-gradient-ar-${theme}-from to-gradient-ar-${theme}-to text-center text-lg font-semibold text-white transition-all duration-200 ease-in-out hover:scale-101 active:scale-100 active:shadow-none`}
                            onClick={() => downloadCertificate()}
                        >
                            <img className="w-[26px] h-[26px]" src={download} alt="Download" />
                        </button>
                        {pdfUrl ? (
                            <iframe src={pdfUrl} width="100%" height="592px" allowFullScreen={true}></iframe>
                        ) : (
                            <img
                                className="pointer-events-none select-none shadow-longshadow rounded-[6px]"
                                src={`/images/temp-certificate.png`}
                                alt="Votre certificat"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
